/*
 * Die RÜCKFRAGEN der Verwaltung vor Stilllegen und Entfernen (Hausregel „Bestätigung vor Datenänderung“, 19.10.2026;
 * Hausregel „durchgängig einheitliches Design“, 02.11.2026). Schlüssel englisch, Werte deutsch (Hausregel „Texte in
 * Properties“).
 *
 * STILLLEGEN fragt wie am Unternehmen (`unternehmen.tsx`, „‹Name› stilllegen?“): klein, nicht rot, der
 * Satz sagt, wo der Eintrag danach fehlt, was bleibt und dass „Wieder einschalten“ es zurücknimmt. Der Name steht
 * OHNE Anführungszeichen — so wie in den meisten Fragen des Bestands, die einen Namen tragen (Review H4); damit ein
 * Name wie „Vertrag“ nicht als Sache gelesen wird, nennt der Titel die Art davor („Dateityp Vertrag stilllegen?“). Wieder einschalten selbst fragt nicht — es stellt nur her, was vorher war (wie am
 * Unternehmen). Die Folgen stehen so in db/repositories (`product.ts`, `fileType.ts`, `taxRate.ts`: stillgelegt heisst
 * `active = 0`, an Bestehendem weiter referenzierbar, die Auswahl filtert auf `nurAktive`).
 *
 * ENTFERNEN löscht eine hochgeladene Datei — danach ist sie weg, deshalb in Gefahr-Gestalt.
 *
 * Wann rot und wann nicht: die Rot-Regel im Kopf von `useBestaetigung` (@kundeninfo/ui).
 */
const REVERSIBLE = "„Wieder einschalten“ nimmt das jederzeit zurück.";

export const CONFIRM_TEXT = {
  deactivateTitle: (name: string): string => `${name} stilllegen?`,
  productName: (nummer: string, name: string): string => `Artikel ${nummer} ${name}`,
  fileTypeName: (name: string): string => `Dateityp ${name}`,
  deactivate: "Stilllegen",
  deactivateProduct: "Der Artikel lässt sich danach nicht mehr in Vorgänge einfügen; erfasste Positionen bleiben "
    + `unverändert. ${REVERSIBLE}`,
  deactivateFileType: "Der Dateityp steht danach beim Hochladen nicht mehr zur Wahl; abgelegte Dateien behalten ihn. "
    + REVERSIBLE,
  deactivateTaxRate: "Die Zeitscheibe steht danach für neue Positionen nicht mehr zur Wahl; erfasste Artikel und "
    + `Positionen behalten sie. ${REVERSIBLE}`,
  /** Zeitscheibe eines Steuersatzes: Name der Serie und ihr Beginn. */
  taxRateName: (name: string, ab: string): string => `Zeitscheibe ${name} ab ${ab}`,

  removeTitle: (was: string): string => `${was} entfernen?`,
  signatureOf: (name: string): string => `Unterschrift von ${name}`,
  logoOf: (variante: string, firma: string): string => `${variante} von ${firma}`,
  remove: "Entfernen",
  removeLogo: "Die hochgeladene Datei wird gelöscht; danach gilt die Standarddatei, wenn es eine gibt.",
  removeSignature: "Die hinterlegte Unterschrift wird gelöscht; neu erzeugte Belege tragen sie danach nicht mehr.",
};
